import type { ItemType } from "./ItemOfStore";

export function isSameItem(
  itemA: { type: ItemType; id: number } | null | undefined,
  itemB: { type: ItemType; id: number } | null | undefined
) {
  if (itemA == null || itemB == null) return false;
  return itemA.type === itemB.type && itemA.id === itemB.id;
}
